import { DashboardFavouriteLayout } from 'app/area/dashboard/types-store';
import { DrillDownCallback, CaseViewCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';

export interface DashboardContainerExternalProps {
  dashboardType: number;
  mainFavouriteId?: number;
  showDescription: boolean;
  location: {
    pathname: string;
    query: any;
  };
  hideFilters?: boolean;
}

export interface FavouriteContainerExternalProps {
  mainFavouriteId: number;
  dashboardModelFavourite: DashboardFavouriteLayout;
  favouriteLayoutAttributes: { [key: string]: string | boolean };
  loadFavouriteDataModel: (favouriteId: number) => void;
  drillDown: DrillDownCallback;
  caseview: CaseViewCallback;
  intl: any;
  translation: any;
  requestCustomWidth?: (id:number, width: number) => void;
}

/*
 * The definition of the dashboard, including basic favourite layout information.
 */
export enum DashboardAccessType {
  LimitedAccess =  1,
  OpenDashboard = 2
}
